import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #LOADING-INDICATOR
\*------------------------------------ */
/**
 * 1) Loading indicator wrapper, e.g., the host
 */
:host {
  display: block;
  line-height: 0;
}

/**
 * Loading indicator element
 */
.cat-c-loading-indicator {
  display: inline-block;
  height: calc(var(--size-base-unit) * 3);
  width: calc(var(--size-base-unit) * 3);
}

.cat-c-loading-indicator svg {
  display: block;
  width: 100%;
  height: 100%;
}

/**
 * Loader SVG paths
 */
[class^=cat-loader-path] {
  fill: var(--cat-theme-color-background-xstrong);
  animation: fadeInOut 0.8s linear infinite;
  opacity: 0;
  will-change: opacity;
  /**
   * Inverted loader
   */
}
.cat-c-loading-indicator--inverted [class^=cat-loader-path] {
  fill: var(--cat-theme-color-background-default);
}

/**
 * SVG path animation delays
 */
.cat-loader-path--1 {
  animation-delay: 0s;
}

.cat-loader-path--2 {
  animation-delay: 0.1s;
}

.cat-loader-path--3 {
  animation-delay: 0.2s;
}

.cat-loader-path--4 {
  animation-delay: 0.3s;
}

.cat-loader-path--5 {
  animation-delay: 0.4s;
}

.cat-loader-path--6 {
  animation-delay: 0.5s;
}

.cat-loader-path--7 {
  animation-delay: 0.6s;
}

.cat-loader-path--8 {
  animation-delay: 0.7s;
}

/**
 * Spinning animation
 */
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  85% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
/**
 * Small loader
 */
.cat-c-loading-indicator--small {
  height: calc(var(--size-base-unit) * 2);
  width: calc(var(--size-base-unit) * 2);
}
`;
       